










import Vue from 'vue';

export default Vue.extend({
  name: "VSelect",
  props: {
    value: { type: [String, Number, Object] } as any,
    options: { type: Array, required: true } as any,
    searchable: { type: Boolean, default: false } as any,
    labelInValue: { type: Boolean, default: false } as any,
    disabled: { type: Boolean, default: false } as any,
    placeholder: String,
    showPlaceholderWhileLoading: { type: Boolean, default: false } as any,
  },
  data() {
    return {
      loading: false,
      // @ts-ignore
      selectedOption: this.initialValue as any
    };
  },

  mounted() {
    this.selectedOption = this.initialValue
  },

  watch: {
    value(newValue) {
      // @ts-ignore
      if (this.labelInValue) {

        if (!newValue) this.selectedOption = { key: newValue }

        this.selectedOption.value = newValue.key || newValue.value
        this.selectedOption.key = newValue.key || newValue.value

      } else {
        this.selectedOption = newValue
      }
    }
  },

  methods: {
    handleChange(value: any) {
      this.selectedOption = value
      if (this.labelInValue && this.value) {
        this.selectedOption.value = value.key
      }

      this.$emit('input', value);
    },

    toggleLoading(status: boolean) {
      // @ts-ignore
      this.loading = status;
    },

    filterOption(input: string, option: any) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  },

  computed: {
    initialValue(): any {
      const defaultValue: any = this.labelInValue ? (this.value || { key: null }) : this.value

      if (this.labelInValue && this.value) {
        defaultValue.key = (this.value as any).value
      }

      return defaultValue;
    },
  }
});
